import React from "react";
import { useNavigate } from "react-router-dom";
import { HiArrowRight, HiOutlineChevronLeft } from "react-icons/hi";
import "./PricingPlans.css";

const PricingPlans = () => {
  const navigate = useNavigate();

  const plans = [
    {
      title: "Growth Plan",
      price: "10.99",
      tag: "Popular Choice",
      description: "Perfect for Serious creators scaling their income",
      features: [
        "Everything in Basic, PLUS:",
        "More Personalized Options",
        "Priority Support (12-hour response)",
        "8% Revenue Share",
        "14 Days Payouts",
        "5,000 LKR (one-time) Joining fee",
      ],
      isPopular: true,
    },
    {
      title: "Pro Creator Plan",
      price: "14.99",
      tag: null,
      description: "Perfect for Established creators maximizing earnings",
      features: [
        "Everything in Growth, PLUS:",
        "Custom Monetization Strategies",
        "Dedicated Support Agent",
        "5% Revenue Share",
        "Weekly Payouts",
        "5,000 LKR (one-time) Joining fee",
      ],
      isPopular: false,
    },
  ];

  return (
    <div className="pricing-container">
      {/* Back Button */}
      <button className="back-btn" onClick={() => navigate(-1)}>
        <HiOutlineChevronLeft /> Back to Dashboard
      </button>

      {/* NEW HERO SECTION */}
      <header className="pricing-hero">
        <span className="hero-badge">Start Earning Today</span>
        <h1>Transparent Pricing</h1>
        <p>
          Choose the perfect plan for your content creation journey. <br />
          All plans include instant monetization access and your personal platform.
        </p>
      </header>

      <div className="plans-grid">
        {plans.map((plan, index) => (
          <div key={index} className={`plan-card ${plan.isPopular ? "popular" : ""}`}>
            {plan.isPopular && <div className="popular-badge">{plan.tag}</div>}
            
            <div className="plan-header">
              <h3>{plan.title}</h3>
              <div className="price-section">
                <span className="currency">$</span>
                <span className="amount">{plan.price}</span>
                <span className="period">/mo</span>
              </div>
              <p className="plan-desc">{plan.description}</p>
            </div>

            <ul className="features-list">
              {plan.features.map((feature, i) => (
                <li key={i}>
                  <span className="dot"></span>
                  {feature}
                </li>
              ))}
            </ul>

            <button className="get-started-btn">
              Get Started <HiArrowRight />
            </button>
            <p className="tax-disclaimer">*exclusive of applicable taxes</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingPlans;